import React from 'react';
import { BadgeCor } from './GridAniversariantes';
import { formatarDataAniversario } from '~/Services/GES/AniversariantesService';

// W-0607 — RNF-04: variante mobile da consulta de aniversariantes.
// key estável derivada do dado: `${codigo_conta}-${tipo_union}` (LICOES §1.5).

const Linha = ({ rotulo, valor }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '4px 0',
      fontSize: '13px',
      borderBottom: '1px solid #f0f0f0',
    }}
  >
    <span style={{ fontWeight: 600, color: '#555', marginRight: '8px' }}>
      {rotulo}
    </span>
    <span style={{ textAlign: 'right' }}>
      {valor != null && valor !== '' ? valor : '-'}
    </span>
  </div>
);

const CardListMobile = ({ dados = [] }) => {
  if (!dados || dados.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '24px', color: '#666' }}>
        Nenhum registro encontrado
      </div>
    );
  }

  return (
    <div>
      {dados.map(item => (
        <div
          key={`${item.codigo_conta}-${item.tipo_union}`}
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '8px',
            backgroundColor: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '6px',
            }}
          >
            <strong style={{ fontSize: '14px' }}>
              {item.nome_contato || '-'}
            </strong>
            <BadgeCor corCredito={item.cor_credito} />
          </div>
          <Linha
            rotulo="Aniversário"
            valor={formatarDataAniversario(item.data_aniversario)}
          />
          <Linha rotulo="Celular" valor={item.celular} />
          <Linha rotulo="Conta" valor={item.codigo_conta} />
          <Linha rotulo="Razão Social" valor={item.razao_social} />
          <Linha rotulo="Cidade" valor={item.cidade} />
          <Linha rotulo="UF" valor={item.estado} />
          <Linha rotulo="DDD" valor={item.ddd} />
          <Linha rotulo="Fone" valor={item.fone} />
          <Linha rotulo="Cargo" valor={item.codigo_cargo} />
          <Linha rotulo="Vendedor" valor={item.codigo_vendedor} />
          <Linha rotulo="Tipo" valor={item.tipo_union} />
        </div>
      ))}
    </div>
  );
};

export default CardListMobile;
